// @ts-check
/** Cosmetic state consumes events, never writes simulation state. */
export function createEffects() {
  /** @type {{x:number,y:number,age:number,broken:boolean}[]} */
  let sparks = [];
  return {
    /** @param {import('../game/types.js').GameEvent} event */
    accept(event) {
      if (event.type === 'restarted') sparks = [];
      if (event.type === 'block-activated' || event.type === 'block-broken') {
        if (sparks.length >= 64) sparks.shift();
        sparks.push({ x: event.x, y: event.y, age: 0, broken: event.type === 'block-broken' });
      }
    },
    /** @param {number} dt */
    step(dt) { for (const spark of sparks) spark.age += dt; sparks = sparks.filter((spark) => spark.age < 0.5); },
    get sparks() { return sparks; },
  };
}
